module.exports = __webpack_public_path__ + "static/media/logo.5d5d9eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainPage/logo.svg
// module id = 208
// module chunks = 0